import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import WeaponsSection from './components/WeaponsSection';
import ConflictsSection from './components/ConflictsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CalculatorSection from './components/CalculatorSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import EarningsToast from '@/components/feature/EarningsToast';

const HomePage = () => {
  return (
    <div className="bg-[#0d0d0d] min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <WeaponsSection />
      <ConflictsSection />
      <TestimonialsSection />
      <CalculatorSection />
      <ContactSection />
      <Footer />
      <EarningsToast />
    </div>
  );
};

export default HomePage;
